import Icon, { IconProps } from './Icon';

import NewAskAsperLogoIcon from '../../../assets/icons/NewAskAsperLogo.svg?react';

const NewAskAsperLogo: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <NewAskAsperLogoIcon />
        </Icon>
    );
};

export default NewAskAsperLogo;
